module.exports = __webpack_public_path__ + "static/media/Bell.00574134.svg";